import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { nkServices } from '../../servicios/app.nkservicios.services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { AppUtilService } from '../../servicios/app.util.service';
import { AtributosService } from '../../servicios/atributos.service';
import { Router } from '@angular/router';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { environment } from 'src/environments/environment';
import { forIn } from 'lodash';

@Component({
  selector: 'app-form-test-preguntas',
  templateUrl: './form-test-preguntas.component.html',
  styleUrls: ['./form-test-preguntas.component.css']
})
export class FormTestPreguntasComponent implements OnInit {
  @ViewChild('minutes', { static: true }) minutes: ElementRef;
  @ViewChild('seconds', { static: true }) seconds: ElementRef;
  secon: any;
  min: any;
  tmp_test:any;
  tmp_test_seg:any;
  test:any;
  test_final:any;
  text:any;
  text_cat:any;
  text_v:any;
  text_f:any;
  text_t:any;
  con:any = false;
  b_sig:any = false;
  b_rp:any = true;
  cont:any = 0;
  cont_test:any = 0;
  cont_test_ev:any = 0;
  cont_test_err:any = 0;
  test_f:any = false;
  test_n:any = [];
  param:any;
  param_2:any;
  param_3:any = true;
  card_test:any = true;
  forma:FormGroup;
  constructor(
            private render:Renderer2,
            private servicio:nkServices,
            private fb:FormBuilder,
            private dialog: MatDialog,
            private hashkey:HashKeyServices,
            private util:AppUtilService,
            private atrb:AtributosService,
            private router:Router,
            private notifi:ToastNotificationService,
            private dialogRef: MatDialogRef<FormTestPreguntasComponent>,
      ///en el injectable llega la informacion del metodo padre en data
      @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    console.log(data, 'primero');
    this.param = this.atrb.COMPLETACION.toUpperCase();
    this.forma = fb.group({
      'cod_usuario': [''],
      'cod_app': [''],
      'cod_empresa': [''],
      'val_def': [''],
      'api': [''],
      'operacion': [''],
      'accion': [''],
    });
  }

async ngOnInit(){
await this.getParametrosApp();
await this.testApp();
this.min = parseInt(this.tmp_test);
this.secon = parseInt(this.tmp_test_seg);
        if (this.min < 10) {
          this.minutes.nativeElement.innerText = '0' + this.min;
        }else{
          this.minutes.nativeElement.innerText = this.min;
        }
        if (this.secon < 10) {
          this.seconds.nativeElement.innerText = '0' + this.secon;
        }else{
          this.seconds.nativeElement.innerText = this.secon;
        }
   await this.interval();  
  }
  async getParametrosApp(){
    try {
     
      /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
      let valor = {
        termino: await this.atrb.DEF.toUpperCase(),
        cod_rol: await this.atrb.ROL_USUARIOS.cod_rol,
        cod_app : await this.hashkey.encrypt(environment.path_token),
        cod_empresa : await localStorage.getItem('cod_empresa'),
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
      }
      const response = await this.servicio.ApiResthttp(valor).toPromise();
      let img_val;
      let tm_val;
      for (const i in response) {
        img_val = response[i].constante_app.split('_');
        if (img_val[0].toUpperCase() === await this.atrb.IMG.toUpperCase()) {
        }
        if (img_val[0].toUpperCase() === await this.atrb.TXT.toUpperCase()) {
        }
        if (img_val[0].toUpperCase() === await this.atrb.TMP.toUpperCase()) {
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.TMP_TEST.toUpperCase()) {
            tm_val = response[i].val_def.split(':');
            this.tmp_test = tm_val[0];
            this.tmp_test_seg = tm_val[1];
          }
        }
      }
      
    } catch (error) {
      
      console.log(error);
    }
  }
  async testApp(){
    try {
      /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
      let valor = {
        termino: await this.atrb.FUNC.toUpperCase(),
        cod_app : await this.hashkey.encrypt(environment.path_token),
        cod_empresa : await localStorage.getItem('cod_empresa'),
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
      }
      const response = await this.servicio.ApiResthttp(valor).toPromise();
      let response_ = [];
      for (const i in response) {
        if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.FNC_TEST.toUpperCase()) {
          response_.push(response[i]);
        }
      }
      this.cont_test++;
      let op_ram = [];
      let random = Math.floor((Math.random() * response_.length) );
      this.test = response_[random].val_def;
      this.text_cat = response_[random].val_cat.split(',');
      this.text_t = this.text_cat[2];
      this.test_n = [...response_];
      this.text = this.test.split(' ');
      /* this.text_v = this.test.split(' '); */
      this.text_v = this.text;
      /* this.text_f = await this.util.arrayRamdom(this.text); */
      op_ram = [this.text_cat[0], this.text_cat[3], this.text_cat[4], this.text_cat[5]];
      this.text_f = await this.util.arrayRamdom(op_ram);
      /* let val = Math.floor((Math.random() * this.text.length) ); */
      let val = this.text_cat[0];
      this.test_n = this.test_n.filter(valor => valor.val_def !== this.test_n[random].val_def);
      this.param_2 = this.text_cat[1].toUpperCase();
      this.param_3 = this.text_cat[3].length > 10 ? false : true;
      console.log(this.param_3);
      console.log(this.param_2);
      console.log(this.param);
      for (const i in this.text_v) {
        if (this.text_v[i].toUpperCase() === val.toUpperCase() && this.text_cat[1].toUpperCase() === await this.atrb.COMPLETACION.toUpperCase()) {
          this.text_v[i] = '_ _';
        }
      }
      this.test_final = await this.util.remplazo_coma_espacio(this.text_v.toString());
    } catch (error) {
      console.log(error);
    }
  }
  async interval(){
    if (this.con) {
      return;
    }
    this.cont ++;
    console.log(this.cont);
      setTimeout(async () => {
        this.secon--;
        if (this.secon < 10) {
          this.seconds.nativeElement.innerText = '0' + this.secon;
        }else{
          this.seconds.nativeElement.innerText = this.secon;
        }
      if(this.secon <= 0){
        this.min--;
        if (this.min >= 0 ) {
          if (this.min < 10) {
            this.minutes.nativeElement.innerText = '0' + this.min;
            this.secon = 60;
            this.interval();
          }else{
            this.minutes.nativeElement.innerText = this.min;
            this.secon = 60;
            this.interval();
          }
        }else{
          this.cont = 0;
          this.con = true;
          this.b_sig = true;
          this.b_rp = false;
          await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.tiempo_agotado_test);
          return;
        }
      }else{
        this.interval();
      }
      }, 1000);
      
    }
    async  modalrespuesta(){
      try {
        var accion2 = '';
        var dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:this.data.id_cliente,
                accion:accion2},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if(result !== await this.atrb.CERRAR){
            this.forma.patchValue({
              val_def: this.cont_test,
              accion: await this.atrb.prueba_basica
            });
              await this.util.cerrarSpinner();
              this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(error.error.message);
      }
    }
    async cerrarmodal(){
      try {
        let accion = 'salir';
        let dialogRefp = this.dialog.open(FormmMsgComponent, {
          width: '100vw',
          maxWidth: '100vw',
          height:'auto',
          data: {id:'',
                accion:accion},
          disableClose: true,
          panelClass: 'pedidos_modal',
          backdropClass: "bdrop"
        });
        dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
          if (result !== await this.atrb.CERRAR) {
            this.con = true;
            this.forma.patchValue({
              accion: await this.atrb.CERRAR
            });
              await this.util.cerrarSpinner();
              this.dialogRef.close(this.forma.value);
          }else{
            await this.util.cerrarSpinner();
          }
        });
      } catch (error) {
        console.log(error);
     }
    }
    async cambiarTest(){
      try {
        await this.util.abrirSpinner();
        this.con = false;
        this.b_sig = false;
        this.b_rp = true;
        this.secon = parseInt(this.tmp_test_seg);
        this.min = parseInt(this.tmp_test);
        if (this.min < 10) {
          this.minutes.nativeElement.innerText = '0' + this.min;
        }else{
          this.minutes.nativeElement.innerText = this.min;
        }
        if (this.secon < 10) {
          this.seconds.nativeElement.innerText = '0' + this.secon;
        }else{
          this.seconds.nativeElement.innerText = this.secon;
        }
        await this.interval(); 
          /* let random = Math.floor((Math.random() * this.test_n.length) );
          this.test = this.test_n[random].val_def;
          this.text = this.test.split(' ');
          this.text_v = this.test.split(' ');
          this.text_f = await this.util.arrayRamdom(this.text);
          let val = Math.floor((Math.random() * this.text.length) );
          this.test_n = this.test_n.filter(valor => valor.val_def !== this.test_n[random].val_def);
          this.text_v[val] = '_ _';
          this.test_final = await this.util.remplazo_coma_espacio(this.text_v.toString()); */
          this.cont_test++;
          let op_ram = [];
          let random = Math.floor((Math.random() * this.test_n.length) );

          this.test = this.test_n[random].val_def;
          this.text_cat = this.test_n[random].val_cat.split(',');
          this.text_t = this.text_cat[2];
          this.text = this.test.split(' ');
          this.text_v = this.text;
          op_ram = [this.text_cat[0], this.text_cat[3], this.text_cat[4], this.text_cat[5]];
          this.text_f = await this.util.arrayRamdom(op_ram);
          let val = this.text_cat[0];
          this.test_n = this.test_n.filter(valor => valor.val_def !== this.test_n[random].val_def);
          this.param_2 = this.text_cat[1].toUpperCase();
          this.param_3 = this.text_cat[3].length > 10 ? false : true;
          for (const i in this.text_v) {
            if (this.text_v[i].toUpperCase() === val.toUpperCase() && this.text_cat[1].toUpperCase() === await this.atrb.COMPLETACION.toUpperCase()) {
              this.text_v[i] = '_ _';
            }
          }
          this.test_final = await this.util.remplazo_coma_espacio(this.text_v.toString());
          if (this.test_n.length <= 0) {
            this.test_f = true;
            /* this.con = true; */
          }
        await this.util.cerrarSpinner();
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log();
      }
    }
    async rpctTest(xvalor:any){
      try {
        await this.util.abrirSpinner();
        this.b_rp = false;
        this.b_sig = true;
        this.con = true;
        this.cont = 0;
        console.log(this.text_cat[0].toUpperCase()+' '+xvalor.toUpperCase() ,'opciones');
        if (xvalor.toUpperCase() === this.text_cat[0].toUpperCase()) {
          this.cont_test_ev++;
          /* console.log(this.cont_test_ev,'correctas');
          await this.notifi.success(await this.atrb.MENSAJES_FIJOS.respuesta_correcta); */
        }else{
          this.cont_test_err++;
          /* console.log(this.cont_test_err,'incorrectas');
          await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.respuesta_incorrecta); */
        }
        await this.util.cerrarSpinner();
      } catch (error) {
        await this.util.cerrarSpinner();
        console.log();
      }
    }
}
